export const prevalences: string[] = [
	"Faible prévalence (+)",
	"Prévalence moyenne (++)",
	"Forte prévalence (+++)",
	"Prévalence suraigüe  (++++)",
];
export const formes: string[] = [
	"Présence (+)",
	"Forme subaigüe (++)",
	"Forte aigue (+++)",
	"Forme suraigüe  (++++)",
	"Forme chronique",
];
export const molecules: string[] = [
	"Fluméquine",
	"Florfenicol",
	"Trimetoprime - Sulfadiazine",
	"Oxytetracycline",
	"Enrofloxacine",
	"Doxycycline",
	"Amoxicilline",
	"Vitamine C",
	"Forcivitol",
];
export const dureetraitements: string[] = [
	"5 jours",
	"6 jours",
	"7 jours",
	"8 jours",
	"9 jours",
	"10 jours",
	"11 jours",
	"12 jours",
	"3 à 5 jours",
	"5 à 8 jours",
	"8 à 10 jours",
];
export const frequences: string[] = [
	"+",
	"++",
	"+++",
	"++++",
	"Très faible",
];
export const severite: string[] = [
	"+",
	"++",
	"+++",
	"++++",
	"Très faible",
];
export const environment = {
	production: true,
	isMockEnabled: false,
	authTokenKey: 'authce9d77b308c149d5992a80073637e4d5',
	firebase: {
		apiKey: 'AIzaSyBh35yeTmKwVpKOvpOcwsHjmft3W6GTlF4',
		authDomain: 'majdi-test-8e820.firebaseapp.com',
		databaseURL: 'https://majdi-aa1c1-default-rtdb.firebaseio.com/',
		projectId: 'majdi-test-8e820',
		storageBucket: 'majdi-test-8e820.firebasestorage.app',
		messagingSenderId: '1097620992758',
		appId: '1:1097620992758:web:89d4c562947129f5a432d7',
		measurementId: 'G-BGLMM8KWB1',
	},
	frequences:frequences,
	severite:severite,
	prevalences :prevalences,
	formes :formes,
	molecules :molecules,
	dureetraitements :dureetraitements,
};
